(function ($) {
    $(document).ready(function () {
        extraServices();
    });

    function extraServices() {
        var wrap = $('.section.services_grid .list');

        if (wrap.length > 0) {
            wrap.each(function () {
                var single_wrap = $(this),
                    children = single_wrap.children(),
                    container = wrap.find('.container'),
                    pager = wrap.find('.pager'),
                    hasCarousel = false;

                if (is_phone) {
                    if (children.length > 1) {
                        hasCarousel = true;
                    }
                } else if (is_mobile) {
                    if (children.length > 2) {
                        hasCarousel = true;
                    }
                } else {
                    if (children.length > 3) {
                        hasCarousel = true;
                    }
                }
                if (hasCarousel) {
                    single_wrap.on("init", function () {
                        lazyLoadInstance.update();
                    });
                    single_wrap.slick({
                        autoplay: false,
                        arrows: true,
                        dots: true,
                        infinite: true,
                        prevArrow: accor_arrow_prev,
                        nextArrow: accor_arrow_next,
                        appendDots: wrap.closest('.section').find('.pager'),
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        variableWidth: false,
                        centerMode: true,
                        centerPadding: '5%',
                        rtl: $('html').attr('dir') === 'rtl',
                        responsive: [
                            {
                                breakpoint: 1440,
                                settings: {
                                    adaptiveHeight: true,
                                    // centerMode: false,
                                }
                            },
                            {
                                breakpoint: 968,
                                settings: {
                                    slidesToShow: 1,
                                    slidesToScroll: 1,
                                    adaptiveHeight: true,
                                    centerMode: false
                                }
                            },
                        ]
                    });
                } else {
                    pager.css('display', 'none');
                    var maxWidth;
                    if (is_desktop_xxl) {
                        maxWidth = '1600px';
                    } else if (is_desktop_large) {
                        maxWidth = '1160px';
                    } else if (is_desktop) {
                        maxWidth = '980px';
                    } else if (is_tablet_portrait) {
                        maxWidth = '740px';
                    } else if (is_phone) {
                        maxWidth = '100%';
                    }
                    container.css('max-width', maxWidth);
                }
            })
        }
    }

})(jQuery);